import React from "react"
import MQuote from "../blocks/m_quote"
import MImageQuoteCarousel from "../blocks/m_image_quote_carousel"

const MQuoteSwitch = (props) => {
  if (props.data.quote_with_image == 1
      && Array.isArray(props.data.image_quote)
      && props.data.image_quote.length) {
    return MImageQuoteCarousel(props)
  }
  return MQuote(props)
}

export default MQuoteSwitch
